export const getTopicHeading = (path) =>
    path ? path.match(/[^/]+$/)[0] : null;

export const formatTopicHeading = (title) => {
    if (!title) return "";

    const decodedTitle = decodeURIComponent(title);
    return `TOPIC: ${decodedTitle.toUpperCase()}`;
};
